import React, { useState, useEffect }  from 'react';
import { ResponsiveLine } from '@nivo/line';
import { Container, 
    Row, 
    Col, 
    Button, 
    Dropdown, 
    DropdownButton } from 'react-bootstrap';
import { 
    GetPacientesIngresadosDias,
    GetPacientesEgresadosDias} from '../../Services/Net/Request/StatsService';
import Loading from '../Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSquare } from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';
import 'moment/locale/es';

export default function ChartIE(props)
{
    const [status, setStatus] = useState("");
    const [fechaInicial, setFechaInicial] = useState(moment().subtract(1, 'months'));
    const [fechaFinal, setFechaFinal] = useState(moment());
    const [chart, setChart] = useState([]);
    const [ncols, setNcols] = useState(0);
    const [alldata, setAlldata] = useState(undefined);
    const [typedata, setTypeData] = useState("Ingresos");
    const [filteron, setFilteron] = useState(false);
    const [rangetime, setRangetime] = useState(1);

    moment.locale('es');

    useEffect(() => {
        const abortController = new AbortController();
        setStatus("?");
        const formatdate = "YYYY-MM-DD HH:mm:ss";
    
        var IngPrimise = GetPacientesIngresadosDias(abortController.signal,fechaInicial.format(formatdate),fechaFinal.format(formatdate));
        var EgrPromise = GetPacientesEgresadosDias(abortController.signal,fechaInicial.format(formatdate),fechaFinal.format(formatdate));
    
        Promise.all([IngPrimise,EgrPromise]).then(
          (response) => {
            if (abortController.signal.aborted)
              return;
    
            if (response[0].ok && response[1].ok)
            {
              var ndata = {};
    
              setStatus("");
              var json1 = response[0].json();
              var json2 = response[1].json();
    
              Promise.all([json1,json2]).then((data) =>
              {
                ndata["Ingresos"] = data[0];
                ndata["Egresos"] = data[1];
                setAlldata(ndata);
                setChart(ndata[typedata]);

                setNcols(data[1][0].data.length);
              });
            } else {
                setStatus("Error de conexión");
            }
          }
        ).catch(function(error) { 
          if (!abortController.signal.aborted)
              setStatus("Error de conexión: "+error); });
    
        return () => {
          abortController.abort();
          };
      },[fechaInicial,fechaFinal,props.hospital]);

    function ChangeTypedata(nt)
    {
        setTypeData(nt);
        setChart(alldata[nt]);
    }

    function ChangeRangeTime(nr)
    {
        setRangetime(nr);
        switch(nr)
        {
            case 0: //week
            
                setFechaFinal(moment());
                setFechaInicial(moment().subtract(1, 'weeks'));
            break;
            case 1: //month
            
                setFechaFinal(moment());
                setFechaInicial(moment().subtract(1, 'months'));
            break;
            case 2: //3 months
            
                setFechaFinal(moment());
                setFechaInicial(moment().subtract(3, 'months'));
            break;
            default:
            break;
        }
    }

    return(
        <Container fluid>
            <ChartIEControl
                tipoplab={typedata}
                fechaInicial={fechaInicial}
                fechaFinal={fechaFinal}
                filteron={filteron}
                rangetime={rangetime}
                setfilteron={() => setFilteron(!filteron)}
                setTypedata={(t) => ChangeTypedata(t)}
                setRangetime={(r) => ChangeRangeTime(r)}
                />
            <Loading status={status}/>
            <Row style={
                {width: (60*ncols).toString()+"px", height: "680px"}}
                hidden={status === "?"}
                >
                <ResponsiveLine
                  data={chart}
                  margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                  xScale={{ type: 'point' }}
                  yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                      orient: 'bottom',
                      tickSize: 15,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'Dia',
                      legendOffset: 42,
                      legendPosition: 'middle'
                  }}
                  axisLeft={{
                      orient: 'left',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: typedata,
                      legendOffset: -40,
                      legendPosition: 'middle'
                  }}
                  colors={{ scheme: 'category10' }}
                  pointSize={10}
                  pointColor={{ theme: 'background' }}
                  pointBorderWidth={2}
                  pointBorderColor={{ from: 'serieColor' }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                  />
              </Row>
        </Container>
    )
}

function ChartIEControl(props)
{
    const [opacity, setOpacity] = useState(100);

    window.addEventListener("touchstart",ChartClick);
    window.addEventListener("touchend",ChartEndClick);

    useEffect(() => {
        return () => {
            window.removeEventListener('touchstart', () => {});
            window.removeEventListener('touchend', () => {});
          }
    },[]);

    function ChartClick(event)
    {
        setOpacity(50);
    }

    function ChartEndClick(event)
    {
        setOpacity(100);
    }

    return(
    <div style={{opacity: opacity.toString()+"%"}}>
        <div className="hlgp64">
            <Row style={{position: "fixed", zIndex: "1000", width: "100vw"}}>
                <Col xs={10} sm={10} md={10} lg={10} xl={10}>
                <h2>{props.tipoplab} de pacientes</h2>
                <h4>{props.fechaInicial.format("D MMM YYYY")} al {props.fechaFinal.format("D MMM YYYY")}</h4>
                </Col>
                <Col xs={2} sm={2} md={2} lg={2} xl={2} className="tc">
                <Button style={{marginTop: "24px"}} variant="secondary" onClick={() => props.setfilteron()}>
                    <FontAwesomeIcon icon={faFilter} />
                </Button>
                </Col>
            </Row>
        </div>
        <div className="p8">
            <Row style={{position: "fixed", zIndex: "1000", width: "100vw"}}>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{color: "#1f76b4"}}>
                    <FontAwesomeIcon icon={faSquare}/> Hosp.
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{color: "#2ca02c"}}>
                    <FontAwesomeIcon icon={faSquare}/> Ambulatorio
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} style={{color: "#ff7f0e"}}>
                    <FontAwesomeIcon icon={faSquare}/> Virtuales
                </Col>
            </Row>
        </div>
        <ChartIEFilters 
            filteron={props.filteron}
            titleleft={props.tipoplab}
            rangetime={props.rangetime}
            setTypedata={(t) => props.setTypedata(t)}
            setRangetime={(r) => props.setRangetime(r)}
            />
    </div>
  );
}

function ChartIEFilters(props)
{
    const RangeTimelabs = ["Semana","Mes","Trimestre"]

    if (props.filteron)
    {
        return(
            <div className="p8 hlgp64">
                <Row style={{position: "fixed", zIndex: "1000"}}>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <small className="gray">Evento</small>
                        <DropdownButton title={props.titleleft} variant="secondary">
                            <Dropdown.Item 
                                onClick={() => props.setTypedata("Ingresos")} 
                            >
                                Ingresos
                            </Dropdown.Item>
                            <Dropdown.Item 
                                onClick={() => props.setTypedata("Egresos")} 
                            >
                                Egresos
                            </Dropdown.Item>
                        </DropdownButton>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <small className="gray">Tiempo</small>
                        <DropdownButton title={RangeTimelabs[props.rangetime]} variant="secondary">
                            <Dropdown.Item 
                                onClick={() => props.setRangetime(0)} 
                            >
                                Semana
                            </Dropdown.Item>
                            <Dropdown.Item 
                                onClick={() => props.setRangetime(1)}
                            >
                                Mes
                            </Dropdown.Item>
                            <Dropdown.Item 
                                onClick={() => props.setRangetime(2)} 
                            >
                                Trimestre
                            </Dropdown.Item>
                        </DropdownButton>
                    </Col>
                </Row>
            </div>
        );
    } else {
        return(<></>);
    }
}